import React from 'react';
import _ from 'lodash';
import {
  LayoutCardList,
  LayoutCardSize,
  LayoutCardListHeading,
  LayoutCardType,
} from 'src/modules/layout';
import { withBreakpoints } from 'react-breakpoints';
import Link from 'next/link';
import { ProductEntity, getProductOverviewImage } from 'src/modules/products';
import { GlobalIcon, IconImage } from 'src/modules/global';
import { LayoutCardData } from 'src/modules/layout/components/card/LayoutCard';
import { FormattedMessage, useIntl } from 'react-intl';
import { colSmallCardProps } from 'src/utils/grid';
import { useLocale } from 'src/modules/locale';
import styles from './ProductsListingOverview.module.scss';
import { getImageBreakpointUrl } from 'src/utils/image';

interface ProductsListingOverviewProps {
  headingTitle?: string;
  headingMore?: boolean;
  relatedOverview?: boolean;
  size?: LayoutCardSize;
  products: Array<ProductEntity>;
  values?: Record<string, unknown>;
  link?: string;
  categorySlug?: string;
  oneRow?: boolean;
}

export const useProductCards = (products = [], categorySlug = '', currentBreakpoint) => {
  const intl = useIntl();

  const mappedProducts = products.map((product) => {
    // if (oneRow && columnCount >= maxCardColums) {
    //   return product;
    // }
    // const isHorizontal = isLandscapeAsset(product.assets);
    // columnCount += productCardColumns;
    // if (columnCount > maxCardColums) {
    // const lastCard = productCards.pop();

    if (!product.slug) {
      return null;
    }
    return {
      // id: product.id,
      image: getImageBreakpointUrl(currentBreakpoint, getProductOverviewImage(product)),
      slug: product.slug,
      link:
        // 'products/' +
        // (categorySlug ||
        //   (product.product_categories.length ? product.product_categories[0].slug : 'category')),
        'products/[category]',
      as:
        '/products/' +
        (categorySlug ||
          (product.product_categories?.length ? product.product_categories[0].slug : 'category')) +
        `/${product.slug}`,
      subtitle: product.product_series
        ? intl.formatMessage({
            id: 'page/products/details/designer',
          }) +
          ' ' +
          product.product_series.designer?.name?.replace('Walter K.', 'Walter Knoll') + // Quick way to avoid localising designer "Walter Knoll"
          '.'
        : '',
      title: product.name + '.',
      // colProps: isHorizontal ? colLargeCardProps : colSmallCardProps,
      // footer: product.family,
    };
    // if (isLandscapeAsset(prevProduct) === 2) {
    //   productCards = [lastCard];
    // }
    // }
  }) as LayoutCardData[];

  return _.compact(mappedProducts);
};

// const maxCardColums = 4;

const ProductsListingOverview: React.FunctionComponent<ProductsListingOverviewProps> = (props) => {
  const { getLocalizedObject } = useLocale();
  const {
    headingTitle = 'page/products/details/section_products_subheading',
    headingMore = true,
    size = LayoutCardSize.Small,
    relatedOverview = false,
    // values,
    link = '/products/',
    categorySlug,
    oneRow = true,
    currentBreakpoint,
  } = getLocalizedObject(props);

  // const horizontalProductCards = [];
  // const verticalProductCards = [];
  // let columnCount = 0;
  const productCards = useProductCards(props.products, categorySlug, currentBreakpoint);
  // let productCards: LayoutCardData[];
  // if (oneRow) {
  //   switch (horizontalProductCards.length) {
  //     case 0:
  //       productCards = verticalProductCards.slice(0, 4);
  //       break;
  //     case 1:
  //       productCards = horizontalProductCards.concat(verticalProductCards.slice(0, 2));
  //       break;
  //     default:
  //       productCards = horizontalProductCards.slice(0, 2);
  //   }
  // } else {
  //   productCards = horizontalProductCards.concat(verticalProductCards);
  // }

  const arrowSvg = <GlobalIcon image={IconImage.Details} />;
  return productCards && !!productCards.length ? (
    <div>
      {relatedOverview && (
        <LayoutCardListHeading
          title={headingTitle}
          values={props.values}
          link={link}
          seeAll={headingMore ? 'page/products/details/section_products_more' : null}
          svg={arrowSvg}
          linkClass={styles.seeMore}
        />
      )}

      <LayoutCardList
        type={LayoutCardType.Product}
        size={size}
        objectFit="contain"
        items={productCards}
        truncateTitle={true}
        colProps={oneRow || productCards.length <= 3 ? colSmallCardProps : null}>
        {relatedOverview && headingMore && (
          <Link href={link}>
            <a className={styles.bottomSeeMore}>
              <FormattedMessage id={'page/products/details/section_products_more'} />
              &nbsp;{arrowSvg}
            </a>
          </Link>
        )}
      </LayoutCardList>
    </div>
  ) : null;
};

export default withBreakpoints(ProductsListingOverview);
